export default __webpack_public_path__ + "static/media/synthefi-logo.8ab87882.webp";